import styled from 'styled-components'

export const Button = styled.button`
    width: ${props => props.width || '400px'};
    cursor: pointer;
    border: none;
    transition: all 0.3s ease-in-out;
    &:focus {
        outline: none;
    }
    &:hover {
        transform: scale(1.02) translateY(-4px);
        transition: all .2s ease-in-out;
    }
    height: 49px;
    border-radius: 28px;
    background-image: linear-gradient(93deg, #ffec38 10%, #ffd31a 96%);
    font-family: Lato;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #2b2b2b;
    text-transform: none;
`
export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: ${props => props.height || '100%'};
`
export const AppLogo = styled.a`
    &:focus {
        outline: none;
    }
`